import React from "react"
import Seo from "../../_App/seo"
import { graphql, useStaticQuery } from "gatsby"
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import { DataTable } from 'mantine-datatable';
import '@mantine/core/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion"

export const pageQuery = graphql`
  {
    allStrapiGraduationYearEn : allStrapiGraduationYear( sort: {YearList: DESC}) {
      nodes {
        YearList
        graduate_students {
          Colleges
          Department
          GraduateType
          Studying
          name
          locale
          DepartmentType
        }
      }
    
  }
  
  
}
`;



const GraduateStudentsPage = () => {

  const { language } = useI18next();

  const data = useStaticQuery(pageQuery)

  const { t } = useTranslation();

  const GraduationYearAll = data.allStrapiGraduationYearEn.nodes
 
  return (

    <div className="about-area ptb-80">
      <div className="container">
        <div className="products-details-tabs">
          {GraduationYearAll && GraduationYearAll.map((Mainitem, index) => {
            return (
              <Accordion allowZeroExpanded preExpanded={[0]}>
                <AccordionItem uuid={index}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <span>{Mainitem.YearList}</span>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <DataTable
                      height={400}
                      withTableBorder
                      withColumnBorders
                      striped
                      records={Mainitem.graduate_students.filter((students) => students.locale === language && students.DepartmentType=="FirstDepartment")}
                      columns={[
                        { accessor: 'name', title: t("StudentName"), width: '30%' },
                        { accessor: 'Colleges', title: t("College"), width: '10%' },
                        { accessor: 'Department', title: t("Department"), width: '10%' },
                        { accessor: 'Studying', title: t("Studying"), width: '10%' },
                        { accessor: 'GraduateType', title: t("GraduateType"), width: '10%' },                      
                       
                        


                      ]}
                      scrollAreaProps={{ type: 'never' }}
                      paginationActiveBackgroundColor="grape"

                    />
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            )
          })
          }


        </div>

      </div>
    </div>


  )
}

export const Head = () => <Seo title=" الخريجين  في الجامعة الوطنية" />

export default GraduateStudentsPage
